import { getSubscription } from "@/Services/TherapyApi/Subscriptions";
import SubscriptionTransformer from "@/Modules/Transformers/Subscription";

import useSubscriptionStore from "@/Modules/Subscription/Store";

import { danger } from "@/Utils/Debug";

async function getSubscriptionAH(userId: string): Promise<void> {
  const subscriptionStore = useSubscriptionStore();

  subscriptionStore.isLoading = true;

  try {
    const subscriptionResponse = await getSubscription(userId);

    subscriptionStore.subscription = SubscriptionTransformer.toDomain(subscriptionResponse);
  } catch (error: unknown) {
    danger(error);
    subscriptionStore.subscription = null;
  } finally {
    subscriptionStore.isLoading = false;
  }
}

export default getSubscriptionAH;
